'use client'
import { Table, TableRow, TableHeader, TableCell, TextArea, CheckboxItem, ColorButton, ReplyMessage } from "@/components/ui";
import { defaultQuestion, QuestionIdResponseType } from "@/types";
import { useActionState, useEffect, useState } from "react";
import { getQuestionId, updateQuestionForm } from "@/app/api";
import { SquareCheck, Text } from "@/assets/icons";
import { useRouter } from "next/navigation";
import Form from "next/form";


export function UpdateQuestion({ id }: { id: string }) {
    const [questionData, setQuestionData] = useState<QuestionIdResponseType>()
    const [state, formAction, pending] = useActionState(updateQuestionForm, {
        values: { id: id, content: '', answer: '', status: '' },
        errors: {},
        message: '',
    })

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await getQuestionId(id)
                if (response !== undefined) {
                    setQuestionData(response)
                }
            } catch (e) {
                console.log('Não foi possível buscar o pergunta: ', e)
            }
        }

        fetchUser()
    }, [id]);

    const question = questionData || defaultQuestion

    const router = useRouter();
    if (state.success?.valueOf() === true) {
        setTimeout(() => {
            router.back();
        }, 1000);
    }

    return (
        <div className="p-8">
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Sequência</TableHeader>
                            <TableHeader>Conteúdo</TableHeader>
                            <TableHeader>Autor</TableHeader>
                            <TableHeader>Email do autor</TableHeader>
                            <TableHeader>Status</TableHeader>
                            <TableHeader>Data do envio</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow>
                            <TableCell>{question.sequence}</TableCell>
                            <TableCell>{question.content}</TableCell>
                            <TableCell>
                                {question.user?.name ? 'Usuário' : 'Visitante'} - {question.user?.name || question.visitor?.name}
                            </TableCell>
                            <TableCell>
                                {question.user?.email || question.visitor?.email || 'Não informado'}
                            </TableCell>
                            <TableCell>
                                {question.status === 'PENDING' ? 'Pendente'
                                    : question.status === 'APPROVED' ? "Aprovada"
                                        : question.status === 'REJECTED' ? 'Rejeitada'
                                            : question.status === 'FLAGGED' ? 'Sinalizada'
                                                : 'Pendente'
                                }
                            </TableCell>
                            <TableCell>{new Date(question.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableHeader>Resposta</TableHeader>
                            <TableCell colSpan={4}>{question.answer}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        <TableRow>
                            <TableHeader>Sequência</TableHeader>
                            <TableCell>{question.sequence}</TableCell>
                            <TableHeader>Conteúdo</TableHeader>
                            <TableCell>{question.content}</TableCell>
                            <TableHeader>Autor</TableHeader>
                            <TableCell>
                                {question.user?.name ? 'Usuário' : 'Visitante'} - {question.user?.name || question.visitor?.name}
                            </TableCell>
                            <TableHeader>Email do autor</TableHeader>
                            <TableCell>
                                {question.user?.email || question.visitor?.email || 'Não informado'}
                            </TableCell>
                            <TableHeader>Status</TableHeader>
                            <TableCell>
                                {question.status === 'PENDING' ? 'Pendente'
                                    : question.status === 'APPROVED' ? "Aprovada"
                                        : question.status === 'REJECTED' ? 'Rejeitada'
                                            : question.status === 'FLAGGED' ? 'Sinalizada'
                                                : 'Pendente'
                                }
                            </TableCell>
                            <TableHeader>Data do envio</TableHeader>
                            <TableCell>{new Date(question.createdAt).toLocaleDateString()}</TableCell>
                            <TableHeader>Resposta</TableHeader>
                            <TableCell>{question.answer}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <Form action={formAction} className="flex flex-col gap-3">

                <input type="hidden" name="id" defaultValue={question.id} required />

                {/* question */}

                <div className="flex gap-2 items-center">
                    <Text className="size-4" />
                    <label htmlFor="content">Conteúdo da Pergunta</label>
                </div>
                <TextArea name="content" id="content"
                    defaultValue={question.content || state?.values?.content}
                    placeholder="Conteúdo da Pergunta" />
                {state?.errors?.content && <p>{state.errors.content}</p>}

                {/* answer */}

                <div className="flex gap-2 items-center">
                    <Text className="size-4" />
                    <label htmlFor="answer">Resposta</label>
                </div>
                <TextArea name="answer" id="answer"
                    defaultValue={question.answer || state?.values?.answer}
                    placeholder="Resposta" />
                {state?.errors?.answer && <p>{state.errors.answer}</p>}

                {/* status */}

                <div className="flex gap-2 items-center">
                    <SquareCheck className="size-4" />
                    <label htmlFor="status">Status</label>
                </div>
                <div className="flex flex-wrap gap-5">
                    <CheckboxItem name="status"
                        value="pending" label="Pendente"
                        defaultChecked={question.status === 'PENDING' || state?.values?.status === 'pending'}
                    />

                    <CheckboxItem name="status"
                        value="approved" label="Aprovado"
                        defaultChecked={question.status === 'APPROVED' || state?.values?.status === 'approved'}
                    />


                    <CheckboxItem name="status"
                        value="rejected" label="Rejeitado"
                        defaultChecked={question.status === 'REJECTED' || state?.values?.status === 'rejected'}
                    />


                    <CheckboxItem name="status"
                        value={"flagged"} label="Sinalizado"
                        defaultChecked={question.status === 'FLAGGED' || state?.values?.status === 'flagged'}
                    />

                </div>
                {state?.errors?.status && <p>{state.errors.status}</p>}
                {/* submit */}

                <div className="flex flex-col gap-3 p-4  items-center justify-center">
                    <ColorButton type="submit" disabled={pending}>
                        {pending
                            ? 'Atualizando...'
                            : 'Atualizar'}
                    </ColorButton>
                </div>

            </Form>
            <ReplyMessage message={state?.message || ""} />
        </div>
    )
}